import { createAuthClient } from "better-auth/react";

/**
 * Better-auth client for public pages (login, password reset).
 * HTTP-only via same-origin /api/auth — no Convex client plugin or deployment URL in the bundle.
 */
export const publicAuthClient = createAuthClient({
  baseURL:
    typeof window !== "undefined"
      ? window.location.origin
      : process.env.NEXT_PUBLIC_SITE_URL,
});
